import { useQuery } from '@tanstack/react-query';
// import FormInputAsycnPaginate from '../../shared/FormInputAsycnPaginate';
import FormSelect from '../../shared/FormSelect.jsx';
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from '../../../utils/apiUtils.js';
import { SLOT_NAMES } from '../../../utils/constants.js';

const step = 17

const StepSevenTeen = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const utilizationMgtVendor = getValues("preCertRules.utilizationMgtVendor")

    const { data: serviceRequireingPreCertOptions, isFetching } = useQuery({
        queryKey: ['serviceRequireingPreCertOptions', utilizationMgtVendor?.value],
        // queryFn: async () => {
        //     const results = await fetchTemplateRiderComp({
        //         // category: 'Pre-certification Rules',
        //         searchText: `${utilizationMgtVendor?.value}`,
        //         //bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //         benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //         //  filterText: 'Archimedes'
        //     });
        //     return results
        // },

        // select: (data) => data.hits.hits.map(hit => hit._source.metadata)
        //     .filter(md => md.slotName?.includes('Precert -'))
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanCompName,
        //         label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata
        //     })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            searchText: `${utilizationMgtVendor?.value}`,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.
            filter(md => md.slotName?.includes('Precert -')).
            map((metadata, i) => ({
                value: metadata.benefitPlanRiderHccId,
                label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                additional: metadata,
            })),


        enabled: !!(template?.additional?.benefitPlanTemplateKey && utilizationMgtVendor?.value)
    })

    const { data: archimedesOptions } = useQuery({
        queryKey: ['archimedesOptions', utilizationMgtVendor?.value],
        // queryFn: async () => {
        //     const results = await fetchTemplateRiderComp({
        //         category: SLOT_NAMES.RULES_PRECERT_ARCHIMEDES,
        //         benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //         //   bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //         //  searchText: 'Archimedes'
        //     });
        //     return results
        // },

        // select: (data) => data.hits.hits.map(hit => hit._source.metadata)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanCompName,
        //         label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata
        //     })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.RULES_PRECERT_ARCHIMEDES,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!(template?.additional?.benefitPlanTemplateKey)
    })

    return (
        <>
            {/* <p style={{ padding: '0rem 0rem 1rem 0rem' }}>{template?.label}</p> */}
            <FormSelect
                label={'Utilization Management Vendor'}
                name={'preCertRules.utilizationMgtVendor'}
                control={control}
                options={[{ value: 'Cigna', label: 'Cigna' }, { value: 'Medwatch', label: 'Medwatch' }]}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={({ value }) => {
                    setValue('preCertRules.serviceRequireingPreCert', null)
                }}
            />

            {!isFetching && serviceRequireingPreCertOptions && <FormSelect
                label={'Service Requiring Pre-certification'}
                name={'preCertRules.serviceRequireingPreCert'}
                control={control}
                options={serviceRequireingPreCertOptions}
                errors={errors}
                placeholder="Select..."
                isMulti={true}
            />}

            <FormSelect
                label={'Archimedes'}
                name={'preCertRules.archimedes'}
                control={control}
                options={archimedesOptions}
                errors={errors}
                placeholder="Select..."
                isMulti={true}
            />
        </>
    )
}

export default StepSevenTeen
